module.exports = __webpack_public_path__ + "img/dashboardMHH3.6ca937ac.png";